import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import AbadEc from '@zillow/abad-ec-sdk';
import { IconClose, token, TextButton } from '@zillow/constellation';
import OffMarketContactAgentForm, { fetchAbadHtml, submitContact } from '@zillow/off-market-contact-agent-form';
import { UniversalAnalyticsContext } from '@zillow/universal-analytics-react';
import ResponsiveLightbox from './ResponsiveLightbox';
import { trackHmimhwContactDisplay } from '../utils/gaUtils';
var StyledResponsiveLightbox = styled(ResponsiveLightbox).withConfig({
  displayName: "ContactFormLightBox__StyledResponsiveLightbox",
  componentId: "sc-pvglqm-0"
})(["background-color:", ";padding:50px 20px;"], token('colors.white'));
var StyledIconClose = styled(IconClose).withConfig({
  displayName: "ContactFormLightBox__StyledIconClose",
  componentId: "sc-pvglqm-1"
})(["color:", ";font-size:18px;position:absolute;right:20px;top:20px;"], token('colors.gray600'));
var StyledTextButton = styled(TextButton).withConfig({
  displayName: "ContactFormLightBox__StyledTextButton",
  componentId: "sc-pvglqm-2"
})(["display:flex;"]);

var ContactFormLightbox = function ContactFormLightbox(_ref) {
  var property = _ref.property,
      viewer = _ref.viewer,
      setShowContactAgentForm = _ref.setShowContactAgentForm,
      zatlasEndpoint = _ref.zatlasEndpoint,
      surfaceId = _ref.surfaceId,
      placementId = _ref.placementId,
      isLightboxBackgroundLocked = _ref.isLightboxBackgroundLocked;
  var abadClient = AbadEc.abadClient({
    productId: 'Z',
    appId: 'property-owner-components'
  });

  var _useContext = useContext(UniversalAnalyticsContext),
      areRequiredDimensionsSet = _useContext.areRequiredDimensionsSet;

  useEffect(function () {
    if (areRequiredDimensionsSet) {
      trackHmimhwContactDisplay(surfaceId, placementId);
    }
  }, [areRequiredDimensionsSet, surfaceId, placementId]);
  return /*#__PURE__*/React.createElement(StyledResponsiveLightbox, {
    isLightboxBackgroundLocked: isLightboxBackgroundLocked
  }, /*#__PURE__*/React.createElement(OffMarketContactAgentForm // @ts-expect-error property Type is not matched - fix in STL-4217
  , {
    property: property // @ts-expect-error viewer Type is not matched - fix in STL-4217
    ,
    viewer: viewer,
    zatlasEndpoint: zatlasEndpoint,
    showCheckBox: false,
    centerAlignedNote: true,
    page: "hmimhw",
    location: "sitelink-slot-1",
    abadClient: abadClient,
    onSubmit: function onSubmit(params) {
      return new Promise(function ($return, $error) {
        return $return(submitContact(params));
      });
    },
    onFetchAbadHtml: function onFetchAbadHtml(params) {
      return new Promise(function ($return, $error) {
        return $return(fetchAbadHtml(params));
      });
    }
  }), /*#__PURE__*/React.createElement(StyledTextButton, {
    "data-testid": "contact-close-button",
    onClick: function onClick() {
      return setShowContactAgentForm(false);
    },
    icon: /*#__PURE__*/React.createElement(StyledIconClose, null)
  }));
};

export default ContactFormLightbox;
//# sourceMappingURL=ContactFormLightBox.js.map